import React from 'react';
import Accordion from 'react-bootstrap/Accordion';

// import { Pre } from 'evergreen-ui';

import Form from './Form';
import useStore from '../useStore';
import Amortization from './Amortization';
import { Helmet } from "react-helmet-async";


function EmiCalculator() {
    const [store, dispatch] = useStore();

    return (
<>

          <Helmet>
          <title> Emi Calculator </title>
          <meta name="description" content="Calculate your EMI. Calculator for Personal Finance. Loan Estimator. This Calculator should only be used as a guide."/>
          </Helmet>




      <div className='container' style={{marginTop: '30px' , marginBottom: '30px'}}>
        <h1 className='text-center'>Emi / Loan Calculator </h1>
      <div style={{marginTop: '30px' , marginBottom: '30px'  }}>
        <Form store={store} dispatch={dispatch} />
        {false && <p className='text-justify'>{JSON.stringify(store, null, 2)}</p>}
        <Amortization store={store} />
      </div>

      <h2>What is EMI?</h2>
      <p>
      The Equated Monthly Installment, or EMI, is the monthly payment made to the bank or other financial institution until the debt is entirely paid off. It includes loan interest as well as a portion of the principle amount to be returned. The sum of the principle and interest is divided by the loan's term, or the number of months it must be returned. This sum must be paid on a monthly basis. The interest component of the EMI would be higher at the beginning and subsequently decrease with each payment.
      The precise percentage allocated to principle payment is determined by the interest rate. While your monthly EMI payment will remain constant, the proportion of principle and interest components will alter over time. With each payment, you'll pay more toward the principle and less toward interest.
      </p>
      <h3>Here's how to figure out your EMI:</h3>
      <p>P x R x (1+R)^N / [(1+R)^N-1]</p>
      <p>where <br/>

        P = Principal loan amount<br/>

        N = Loan tenure in months<br/>

        R = Monthly interest rate<br/>

        The rate of interest (R) on your loan is calculated per month.<br/>

        R is rate of interest calculated on monthly basis. (i.e., r = Rate of Annual interest/12/100. If rate of interest is 10.5% per annum, then r = 10.5/12/100=0.00875)<br/>
        </p>

        <p>
        For example, if you borrow ₹10,00,000 from the bank at 10.5% annual interest for a period of 10 years (i.e., 120 months), then EMI = ₹10,00,000 * 0.00875 * (1 + 0.00875)120 / ((1 + 0.00875)120 - 1) = ₹13,493. i.e., you will have to pay ₹13,493 for 120 months to repay the entire loan amount. The total amount payable will be ₹13,493 * 120 = ₹16,19,220 that includes ₹6,19,220 as interest toward the loan.
        </p>
        <p>
        Calculating EMI by hand or in MS Excel for various combinations of principle loan amount, interest rate, and loan duration using the aforementioned EMI method is time consuming, difficult, and error prone. Our EMI calculator automates this calculation for you and provides you with the answer in a split second, along with graphic charts illustrating the monthly schedule and total payment breakdown.
        </p>

        <h3>How Does an EMI Calculator Work?</h3>
        <p>
        Our EMI Calculator is simple to use, easy to comprehend, and quick to use, with rapid results. Using this calculator, you may calculate the EMI for a house loan, a vehicle loan, a personal loan, an education loan, or any other completely amortising loan.<br/> &nbsp; <br/>

        In the EMI Calculator, enter the following information:<br/><br/>
        <ul>
        <li>The principal loan amount that you desire to obtain (rupees)</li>
        <li>Loan duration (years)</li>
        <li>Interest rate (percentage)</li>
        </ul>
        </p>

        <p>
        If you need to input more specific values, you may do so directly in the relevant areas above. The EMI calculator automatically recalculate your monthly payment (EMI) amount as soon as you modify the parameters (after entering the values directly in the input fields).
        </p>

        <h3>Factors Affecting Your Due Amount</h3>
        <p>When intending to apply for a loan, there are several variables to consider. You will be needed to compute equal monthly instalments based on your financial and payback capabilities (EMI). Here are a few things to think about:</p>
        <ul>
          <li><h6>Term of the Loan</h6></li>
          <p>The term of a loan can be lowered or extended. As a result, the EMI amount will either grow or decrease. As a result, choosing the length of a loan is an important consideration that may influence your due amount.</p>
          <li><h6>Rate of Interest</h6></li>
          <p>The interest rate is an important consideration in determining the amount owing in instalments. You may compare products and choose one with a lower interest rate to keep your entire payback low.</p>
          <li><h6>Amount of Loan</h6></li>
          <p>Another important component in establishing your EMI is the loan amount. Your equivalent monthly instalment will be determined based on the loan amount you select.</p>
        </ul>

        <h3>How might an EMI calculator online assist you?</h3>
        <p>The number of credit accounts is increasing at an even faster CAGR of 28%, reaching 107 million at the end of FY18.<br/><br/>

            Regardless of whether you desire a secured or unsecured loan, it is critical that you know how much monthly payment you will have to make before you apply. This is when an EMI calculator in India comes in handy.</p>
        <ul>
          <li>It allows you to receive an exact estimate of your EMI amount and arrange your money appropriately. To increase your chances of loan acceptance, keep your debt-to-income ratio below 50%.</li>
          <li>A loan calculator can help you save time. You are not need to perform difficult computations manually, which can be time-consuming.</li>
          <li>It removes the possibility of error, giving you with a precise estimate every time.</li>
          <li>It is carefully tailored to each form of loan. A house loan's EMI structure differs from that of a personal loan, for example.</li>
        </ul>


        <div style={{marginTop: '30px' , marginBottom: '30px'  }}>   
      <h2>Loan FAQs</h2>
      <Accordion>
      <Accordion.Item eventKey="0">
        <Accordion.Header>What exactly is an EMI?</Accordion.Header>
        <Accordion.Body>
        EMI stands for 'Equated Monthly Installment,' which is the amount you will pay to us on a certain date each month until the loan is fully repaid. 
        The EMI is made up of principle and interest components that are designed in such a manner that the interest component is considerably greater than the principal component in the early years of your loan, 
        while the principal component is much larger in the later half of the loan.
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>What are the advantages of utilising a home loan EMI Calculator?</Accordion.Header>
        <Accordion.Body>
        <p>The following are the advantages of using an EMI calculator for a house loan:</p>
          <h6>It aids in the planning of your money in advance.</h6>
          <p>An EMI calculator may help you arrange your cash flows in advance so that you can make your house loan payments with ease if you take out a home loan. In other words, an EMI calculator may help you with your financial planning and loan servicing.</p>
          <h6>Simple to use</h6>
          <p>EMI calculators are quite basic and straightforward to use. You simply need to submit three input values:</p>
          <ul>
            <li>Loan Amount</li>
            <li>Interest Rate</li>
            <li>Loan Duration</li>
          </ul>
          <p>The EMI calculator will calculate the monthly payment you must make to your home loan provider based on these three input amounts. Some home loan EMI calculators also give a full breakdown of the interest and principal amount you will pay throughout the life of the loan.  </p>
          <h6>It aids in focusing attention on the property hunt.</h6>
          <p>The EMI calculator assists you in determining the optimum home loan amount that best matches your monthly budget by assisting you in determining the loan EMI and tenure that are most appropriate for your financial situation. This helps to narrow down your property search.</p>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
      </div>

      </div>
</>
    );
  }

export default EmiCalculator;